import React from "react";
import Carousels from "../components/businesspage/Carousels";
import Logo from "../components/businesspage/Logo";
import Description from "../components/businesspage/Description";
import Power from "../components/businesspage/Power";
import CardDetails from "../components/businesspage/CardDetails";
import Learning from "../components/businesspage/Learning";
import SuperForm from "../components/businesspage/SuperForm";

function Business() {
  return (
    <div className="programs">
      <Carousels />
      <Logo />
      <Description />
      <Power />
      <CardDetails />
      <Learning />
      <SuperForm />
    </div>
  );
}

export default Business;
